var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57465 2.21635L1.51632 13.9997C1.37079 14.2517 1.29379 14.5374 1.29298 14.8284C1.29216 15.1195 1.36756 15.4056 1.51167 15.6585C1.65579 15.9113 1.86359 16.122 2.11441 16.2696C2.36523 16.4171 2.65032 16.4965 2.94132 16.4997H17.058C17.349 16.4965 17.6341 16.4171 17.8849 16.2696C18.1357 16.122 18.3435 15.9113 18.4876 15.6585C18.6317 15.4056 18.7071 15.1195 18.7063 14.8284C18.7055 14.5374 18.6285 14.2517 18.483 13.9997L11.4247 2.21635C11.2761 1.97144 11.0669 1.76895 10.8173 1.62842C10.5677 1.48789 10.2861 1.41406 9.99965 1.41406C9.71321 1.41406 9.43159 1.48789 9.18199 1.62842C8.93238 1.76895 8.72321 1.97144 8.57465 2.21635V2.21635Z",
    fill: "#FFA500",
    stroke: "#FFA500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.5V9.83333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.1641H10.0083",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.123cf67c4acd7ee2876622beaa2f93f0.svg";
export { ForwardRef as ReactComponent };